import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  selectionListTitleStyle: theme => ({
    color: theme.colors.text.primary,
    lineHeight: 16,
    marginTop: 5,
    fontSize: 18.8,
  }),
  selectionListSubTitleStyle: theme => ({
    marginTop: 7,
    color: theme.colors.textColorTwo,
    fontSize: 15,
  }),
  selectionListContainerStyle: theme => {
    return {
      width: 139,
      height: 69,
      marginRight: 8,
      backgroundColor: theme.colors.cardBackgroundColor,
    };
  },
  contentContainerStyle: {
    paddingLeft: 16.7,
    paddingRight: 8,
  },
});
